export default __webpack_public_path__ + "static/media/de-toeff-vom-polizischt.6aedc32c.webp";